import ReactDOM from "react-dom/client";
import "./styles/main.scss";
import "./i18n";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
